import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';

@Component({
  template: `
     <form [formGroup]="formEdit" >
      <mat-dialog-content>
        <mat-form-field>
          <input matInput [matDatepicker]="picker" formControlName="content" autocomplete="off">
          <mat-datepicker-toggle matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button  (click)="save()">OK</button>
      </mat-dialog-actions>
    </form>
  `,
  styleUrls: ['./file-dialog.component.css']
})
export class FileDialogComponent implements OnInit {
  formEdit: FormGroup;
  content: string;

  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<FileDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data) {
    this.content = data.content;
   }

  ngOnInit(): void {
    this.formEdit = this.formBuilder.group({content: this.content});
  }

  save() {
    this.dialogRef.close(this.formEdit.value);
  }
}

